'use client';

import React, { useState } from 'react';

export function MissedCallCalculator() {
  const [calls, setCalls] = useState(10);
  const [value, setValue] = useState(250);
  const [conversion, setConversion] = useState(67);

  const weeklyLoss = Math.round(calls * (conversion / 100) * value);
  const annualLoss = weeklyLoss * 52;

  return (
    <div className="my-10 p-8 bg-slate-900 rounded-xl text-white shadow-2xl border border-slate-700">
      <h3 className="text-2xl font-bold mb-6 text-blue-400">The "Revenue Leak" Calculator</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
        <div>
          <label className="block text-sm font-medium text-slate-400 mb-2">
            Missed Calls / Week
          </label>
          <input 
            type="range" min="1" max="100" value={calls} 
            onChange={(e) => setCalls(parseInt(e.target.value))}
            className="w-full h-2 bg-slate-700 rounded-lg appearance-none cursor-pointer accent-blue-500"
          />
          <div className="text-xl font-bold mt-2">{calls} calls</div>
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-400 mb-2">
            Avg. Lead Value ($)
          </label>
          <input 
            type="number" value={value} 
            onChange={(e) => setValue(parseInt(e.target.value) || 0)}
            className="w-full bg-slate-800 border border-slate-700 rounded-lg p-2 text-xl font-bold focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-400 mb-2">
            Machine Hang-up Rate (%)
          </label>
          <input 
            type="range" min="1" max="100" value={conversion} 
            onChange={(e) => setConversion(parseInt(e.target.value))}
            className="w-full h-2 bg-slate-700 rounded-lg appearance-none cursor-pointer accent-red-500"
          />
          <div className="text-xl font-bold mt-2 text-red-400">{conversion}% hang up</div>
        </div>
      </div>

      <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700 flex flex-col md:flex-row justify-around items-center gap-6">
        <div className="text-center">
          <p className="text-slate-400 text-sm uppercase tracking-wider font-semibold">Weekly Revenue Leak</p>
          <p className="text-4xl font-black text-red-500">${weeklyLoss.toLocaleString()}</p>
        </div>
        <div className="h-12 w-px bg-slate-700 hidden md:block"></div>
        <div className="text-center">
          <p className="text-slate-400 text-sm uppercase tracking-wider font-semibold">Annual Revenue Lost</p>
          <p className="text-5xl font-black text-red-600">${annualLoss.toLocaleString()}</p>
        </div>
      </div>

      <p className="mt-6 text-center text-slate-400 text-sm italic">
        *Based on industry averages where 67% of callers hang up on voicemail or AI.
      </p>
    </div>
  );
}
